import { render, staticRenderFns } from "./edit-save.vue?vue&type=template&id=635e0589&"
import script from "./edit-save.vue?vue&type=script&lang=ts&"
export * from "./edit-save.vue?vue&type=script&lang=ts&"
import style0 from "./edit-save.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports